import type { ComponentChildren, JSX } from "preact";
import { classNames } from "@gss/common/classNames";
import { InputCheckbox } from "./InputCheckbox";
import { Label } from "./Label";

interface Props {
    className?: string;
    title?: string;
    checked?: boolean;
    inline?: boolean;
    disabled?: boolean;
    invalid?: boolean;
    children: ComponentChildren;
    onChange?: (checked: boolean) => void;
}

export function InputCheckboxLabel({
    className,
    checked,
    title,
    inline,
    disabled,
    invalid,
    children,
    onChange,
}: Props): JSX.Element {
    return (
        <div
            className={classNames(
                "form-check",
                inline && "form-check-inline",
                className,
            )}
        >
            <Label className="form-check-label" title={title}>
                <InputCheckbox
                    checked={checked}
                    disabled={disabled}
                    invalid={invalid}
                    onChange={onChange}
                />
                {children}
            </Label>
        </div>
    );
}
